export default "__VITE_ASSET__Ca$W9HmS__"